import TranslationStore from '../stores/translations_store';
import replacePlaceholders from './replace_placeholders';

function getTranslatedText( translationKey, placeholder = {} ) {
    return replacePlaceholders(
        TranslationStore.getState()[ translationKey ] || translationKey,
        placeholder,
    );
}

export { getTranslatedText };
export default getTranslatedText;
